<template>
  <div :class="['!db-tw-mb-0']">
    <h3
      v-if="label && label.length"
      class="db-title-3 db-title-section-label"
      :class="[
        '!db-tw-mb-2',
        { 'db-tw-mt-12': !isFirstFormElement },
        { 'db-tw-mt-0': isFirstFormElement },
      ]"
    >
      {{ label }}
    </h3>
    <div
      v-else
      class="db-title-section-divider"
      :class="{
        'db-title-section-divider-iframe': isIframe(),
      }"
    />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  /* Label of the title */
  label?: string

  /* Handle if the title is the first element on the form or not */
  isFirstFormElement?: boolean
}>()

function isIframe() {
  return window.location !== window.parent.location
}
</script>

<style scoped>
.db-app .db-title-section-label {
  color: var(--db_main_cta_background_color);
  text-align: left;
}

.db-app .db-title-section-divider {
  height: 1px;
  background-color: var(--db_borders_color);
  opacity: 0.5;
  width: 100%;
  max-width: 570px;
  margin-top: var(--db-spacer-48);
  margin-bottom: var(--db-spacer-48);
}

.db-app .db-title-section-divider-iframe {
  background-color: var(--db_rfp_iframe_body_text_color) !important;
}

@media screen and (max-width: 768px) {
  .db-app .db-title-section-divider {
    width: 100%;
    max-width: 100%;
    margin-top: var(--db-spacer-40);
    margin-bottom: var(--db-spacer-40);
  }
}
</style>
